
import {
    ADD_MENU_ITEM,ADD_NOTE, API_FETCH_MENU_SUCCESS, API_FETCH_USER_SUCCESS, GENERATE_LOGIN_OTP_SUCCESS, REMOVE_ITEM_MENU, ADD_ITEM_MENU_SUCCESS, LOGIN_ERROR,
    CLEAR_LOGIN_ERROR, SEND_LOGIN_SUCCESS,GENERATE_LOGIN_OTP,RESET_USER_DETAILS, VERIFY_CONTACT_NUMBER,VERIFY_CONTACT_NUMBER_SUCCESS,SEND_LOGOUT,SEND_LOGOUT_SUCCESS, ADD_ITEM_TO_CART,
    REMOVE_ITEM_TO_CART, CLEAR_CART, LOAD_CART_FROM_BILL, OPEN_GLOBAL_POPUP, CLOSE_GLOBAL_POPUP,CLEAR_CART_FOR_TABLE,
    API_FETCH_BANNER_SUCCESS, ADD_BANNER_SUCCESS, DELETE_BANNER_SUCCESS,
    UPDATE_BANNER_STATUS_SUCCESS
} from "./constant";
import menuList from "../sample-data/menu.json"
import { produce } from "immer";
import { generateOTPSuccess } from "./action";

const rand = {
    "restaurantName": "a",
    "categories": [
        {
            "catId": "a1B2c3",
            "isSelected": false,
            "category": "Appetizers",
            "items": [
                {
                    "menuId": "123456",
                    "foodName": "Veg Samosa",
                    "description": "Crispy pastry filled with spiced potatoes and peas",
                    "selected": 0,
                    "price": 120,
                    "imageUrl": "https://github.com/user-attachments/assets/fc5a949f-8931-4c3f-bab5-7db4164f732a",
                    "isAvailable": true,
                    "diet": "veg"
                }
            ]
        }
    ]
}

const getCartKey = (payload) => {
  const menuId = payload.menuId;
  const sizeId = payload.selectedSize?.sizeOptionId || "0";
  const addonIds = (payload.selectedAddons || [])
    .map((a) => a.addonItemId)
    .sort()
    .join("-") || "none";
  return `${menuId}_${sizeId}_${addonIds}`;
};


const initialState = { menu: {}, cart: {}, user: null, restros: null, globalPopupKey: null, userDetail:null, loading: false, loggingOut: false };
// const initialState = menuList;
// const initialState = {};

function reducers(state = initialState, action) {

    switch (action?.type) {
        case GENERATE_LOGIN_OTP:
        case VERIFY_CONTACT_NUMBER:
            return { ...state, loading: true };

        case VERIFY_CONTACT_NUMBER_SUCCESS:
            return { ...state, loading: true };

        case ADD_MENU_ITEM:

            return produce(state, draft => {
                draft.menu = action?.payload
                // if (draft.cart[action?.payload?.id]) {
                //     draft.cart[action?.payload?.id].selected+=1
                // } else {
                // const price = draft.menu.categories.find(cat => cat.categoryId === action?.payload?.selectedTab)
                // .items.find(item => item.menuId === action?.payload?.id).price;
                // const k = {
                //     id: action?.payload?.id,
                //     selectedTab: action?.payload?.selectedTab,
                //     price: price,
                //     selected: 1
                // }
                // draft.cart[action?.payload?.id] = k                
                // }
            })

        case ADD_ITEM_MENU_SUCCESS:
            return {
                ...state, menu: {
                    ...state.menu,
                    [action.payload.menuId]: {
                        ...action.payload,
                    }
                }
            }

        // --- REDUCER STATE HANDLER ---

//         case 'LOAD_DRAFT_INTO_CART': {
//   const { tableName = "DIRECT_BILL", billItems, billId } = action.payload;
//   const draftCartItems = {};

//   billItems.forEach((item) => {
//     const cartKey = item.selectedSize?.sizeOptionId 
//       ? `${item.menuId}_${item.selectedSize.sizeOptionId}` 
//       : item.menuId;

//     draftCartItems[cartKey] = {
//       billId: billId,
//       billItemId: item.billItemId || item.id || null,
//       menuId: item.menuId,
//       name: item.foodName || item.name,
//       price: item.price,
//       selected: item.quantity || item.selected || 1,
//       selectedTab: item.categoryId || item.selectedTab || "",
//       selectedSize: item.selectedSize || null,
//       addonSummary: item.addonSummary || "",
//     };
//   });

//   return {
//     ...state,
//     cart: {
//       ...state.cart,
//       [tableName]: draftCartItems,
//     },
//   };
// }

case 'LOAD_DRAFT_INTO_CART': {
  const { tableName = "DIRECT_BILL", billItems = [], billId } = action.payload;
  const draftCartItems = {};

  billItems.forEach((item, index) => {
    // 1. Resolve selected addons array (agar JSON string ya array aaye)
    let addonsList = [];
    if (Array.isArray(item.selectedAddons)) {
      addonsList = item.selectedAddons;
    } else if (Array.isArray(item.addonItems)) {
      addonsList = item.addonItems;
    } else if (typeof item.selectedAddons === "string" && item.selectedAddons.trim() !== "") {
      try {
        addonsList = JSON.parse(item.selectedAddons);
      } catch (e) {
        addonsList = [];
      }
    }

    // 2. Addon Summary text capture
    const addonSummaryText = item.addonSummary || 
      (addonsList.length > 0 ? addonsList.map(a => a.itemName || a.name).join(", ") : "");

    // 3. Unique composite cart key taaki draft resume par koi item overwrite na ho
    const menuId = item.menuId;
    const sizeId = item.selectedSize?.sizeOptionId || item.sizeOptionId || "0";
    const addonKeyPart = addonSummaryText ? encodeURIComponent(addonSummaryText) : "none";
    const cartKey = `${menuId}_${sizeId}_${addonKeyPart}_${item.billItemId || index}`;

    draftCartItems[cartKey] = {
      cartKey: cartKey,
      billId: billId,
      billItemId: item.billItemId || item.id || null,
      menuId: item.menuId,
      name: item.foodName || item.name,
      price: Number(item.price) || 0,
      selected: item.quantity || item.selected || 1,
      selectedTab: item.categoryId || item.selectedTab || "",
      selectedSize: item.selectedSize || (item.sizeOptionId ? { sizeOptionId: item.sizeOptionId, sizeName: item.sizeName } : null),
      selectedAddons: addonsList,
      addonSummary: addonSummaryText,
      note: item.note || "",
    };
  });

  return {
    ...state,
    cart: {
      ...state.cart,
      [tableName]: draftCartItems,
    },
  };
}

case ADD_ITEM_TO_CART:
  return produce(state, (draft) => {
    if (!draft.cart) draft.cart = {};

    const tableName = action?.payload?.tableName || "DIRECT_BILL";
    if (!draft.cart[tableName]) {
      draft.cart[tableName] = {};
    }

    // Resumed bill lines retain their own key and bill-item identity.
    const cartKey = action.payload.cartKey || getCartKey(action.payload);

    if (draft.cart[tableName][cartKey]) {
      draft.cart[tableName][cartKey].selected += 1;
    } else {
      const menuItem = draft.menu?.categories
        ?.flatMap((cat) => cat.items || [])
        ?.find((item) => item.menuId === action?.payload?.menuId);

      // Base ya Selected Size Price
      const basePrice =
        action?.payload?.selectedSize?.price ??
        menuItem?.price ??
        action?.payload?.price ??
        0;

      // Addons Price Total
      const addonsPrice = (action?.payload?.selectedAddons || []).reduce(
        (sum, a) => sum + (Number(a.price) || 0),
        0
      );

      const finalUnitPrice = Number(basePrice) + Number(addonsPrice);
      const activeBillId =
        action?.payload?.billId ||
        Object.values(draft.cart[tableName])[0]?.billId ||
        null;

      draft.cart[tableName][cartKey] = {
        cartKey: cartKey,
        billItemId: null,
        billId: activeBillId,
        menuId: action?.payload?.menuId,
        selectedTab: action?.payload?.selectedTab,
        price: finalUnitPrice,
        selected: 1,
        name: action?.payload?.foodName || menuItem?.foodName,
        selectedSize: action?.payload?.selectedSize || null,
        selectedAddons: action?.payload?.selectedAddons || [],
        note: action?.payload?.note || "",
        addonSummary: action?.payload?.addonSummary || "",
      };
    }
  });

case REMOVE_ITEM_TO_CART:
  return produce(state, (draft) => {
    const tableName = action?.payload?.tableName || "DIRECT_BILL";
    if (!draft.cart?.[tableName]) return;

    const cartKey = action.payload.cartKey || getCartKey(action.payload);

    if (draft.cart[tableName][cartKey]?.selected === 1) {
      delete draft.cart[tableName][cartKey];
    } else if (draft.cart[tableName][cartKey]) {
      draft.cart[tableName][cartKey].selected -= 1;
    }
  });

//         case ADD_ITEM_TO_CART:
//   return produce(state, draft => {
//     if (!draft.cart) draft.cart = {}; 

//     // ✅ FIX: Change fallback from 'default' to 'DIRECT_BILL'
//     const tableName = action?.payload?.tableName || 'DIRECT_BILL';

//     if (!draft.cart[tableName]) {
//       draft.cart[tableName] = {};
//     }

//     const cartKey = action?.payload?.selectedSize?.sizeOptionId 
//       ? `${action?.payload?.menuId}_${action?.payload?.selectedSize?.sizeOptionId}`
//       : action?.payload?.menuId;

//     if (draft.cart[tableName][cartKey]) {
//       draft.cart[tableName][cartKey].selected += 1;
//     } else {
//       const menuItem = draft.menu?.categories
//         ?.flatMap(cat => cat.items || [])
//         ?.find(item => item.menuId === action?.payload?.menuId);

//       const price = action?.payload?.selectedSize?.price || menuItem?.price || action?.payload?.price;

//       // Retain billId from active draft session if adding new items
//       const activeBillId = action?.payload?.billId || Object.values(draft.cart[tableName])[0]?.billId || null;

//       const k = {
//         billItemId: null, 
//         billId: activeBillId,
//         menuId: action?.payload?.menuId,
//         selectedTab: action?.payload?.selectedTab,
//         price: price,
//         selected: 1,
//         name: action?.payload?.foodName || menuItem?.foodName,
//         selectedSize: action?.payload?.selectedSize, 
//         note: action?.payload?.note  
//       };
//       draft.cart[tableName][cartKey] = k;
//     }
//   });
//         case REMOVE_ITEM_TO_CART:
//             return produce(state, draft => {
//                 //const tableName = action?.payload?.tableName || 'default';
//                 // ✅ Correct fallback
// const tableName = action?.payload?.tableName || 'DIRECT_BILL';            
//                 if (!draft.cart[tableName]) return;

//                 const cartKey = action?.payload?.selectedSize?.sizeOptionId 
//                     ? `${action?.payload?.menuId}_${action?.payload?.selectedSize?.sizeOptionId}`
//                     : action?.payload?.menuId;

//                 if (draft.cart[tableName][cartKey]?.selected === 1) {
//                     delete draft.cart[tableName][cartKey];
//                 } else if (draft.cart[tableName][cartKey]) {
//                     draft.cart[tableName][cartKey].selected -= 1;
//                 }
//             });
        
            case CLEAR_CART_FOR_TABLE:
            return produce(state, draft => {
                const tableName = action?.payload?.tableName;
                if (tableName && draft.cart[tableName]) {
                    delete draft.cart[tableName]; // Sirf selected table ka cart delete hoga, baaki safe rahenge!
                }
            });


        case ADD_NOTE:
          return produce(state, draft => {
            const tableName = action?.payload?.tableName || 'default';
            const itemId = action?.payload?.id;
            const noteText = action?.payload?.note;


            if (draft.cart && draft.cart[tableName] && draft.cart[tableName][itemId]) {
            draft.cart[tableName][itemId].note = noteText;
            }
        });

        case LOAD_CART_FROM_BILL:
            return produce(state, draft => {
                draft.cart = {};
                action.payload.forEach(item => {
                    // Find category info from menuList
                    const category = menuList?.categories?.find(cat =>
                        cat.items.some(menuItem => menuItem.menuId === item.menuId)
                    );

                    draft.cart[item.menuId] = {
                        billItemId: item.billItemId,
                        billId: item.billId,
                        menuId: item.menuId,
                        selectedTab: category?.categoryId || null, // enrich with categoryId
                        price: item.price,
                        selected: item.quantity,
                        totalPrice: item.totalPrice || item.price * item.quantity,
                        name: item.name,
                        addonSummary: item.addonSummary || "",
                    };
                });
            });



        case CLEAR_CART:
            return produce(state, draft => {
                draft.cart = {};
            });

        case API_FETCH_MENU_SUCCESS:
            return {
                ...state,
                menu: action?.payload
            };

        case RESET_USER_DETAILS:
            return { ...state, userDetail: null, loading: false };

        case GENERATE_LOGIN_OTP_SUCCESS:
            return {
                ...state,
                userDetail: action?.payload,
               // loading: action?.payload.length > 1 ? false : true
               loading: false
            };
        case SEND_LOGIN_SUCCESS:
            if (action.payload?.restros) {
                return {
                    ...state,
                    restros: action.payload?.restros,
                    user: action.payload,
                    loggingOut: false
                };
            } else {
                return {
                    ...state,
                    user: action.payload,
                    restros: null,
                    loggingOut: false
                };
            }
        case SEND_LOGOUT:
            return {
                ...state,
                loggingOut: true
            };
        case SEND_LOGOUT_SUCCESS:
            return { ...initialState };
        case LOGIN_ERROR:
            return produce(state, draft => {
                draft.loginError = action?.payload;
                draft.user = undefined;
                draft.loading = false;
            });

        case CLEAR_LOGIN_ERROR:
            return {
                ...state,
                loginError: null
            };

        case API_FETCH_USER_SUCCESS:
            return {
                ...state,
                user: action?.payload
            };
        // Guest login removed

        case OPEN_GLOBAL_POPUP:
            return {
                ...state,
                globalPopupKey: action?.payload
            };

        case CLOSE_GLOBAL_POPUP:
            return {
                ...state,
                globalPopupKey: null
            };

        default:
            return state;
    }

}

export default reducers;
